<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const title = field<string>("title", "Table of contents");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:list-tree" accent="reporting">
    <EditorField :label="t('fields.title.label')">
      <Input
        v-model="title"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.title.placeholder')"
      />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Table of Contents"
  fields:
    title:
      label: "Title"
      placeholder: "Table of contents"
</i18n>
